<template>
  <div>
    <a-button @click="addUser">添加用户</a-button>
    <a-divider/>
    <a-drawer width="30%" :visible="show.userInfo" @close="closeForm">
      <a-form-model :model="form.userInfo" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="id" prop="id" style="display: none">
          <a-input v-model="form.userInfo.id" disabled placeholder="新建时自动生成"/>
        </a-form-model-item>
        <a-form-model-item label="用户名" prop="username">
          <a-input v-model="form.userInfo.username" :disabled="form.type===1" placeholder="请输入用户名"
                   @blur="checkUsername"/>
        </a-form-model-item>
        <a-form-model-item label="密码" prop="password" v-if="form.type===0">
          <a-input v-model="form.userInfo.password" placeholder="请输入密码"/>
        </a-form-model-item>
        <a-form-model-item label="重复密码" prop="againPassword" v-if="form.type===0">
          <a-input v-model="form.userInfo.againPassword" placeholder="请重复密码"/>
        </a-form-model-item>
        <a-form-model-item label="姓名" prop="name">
          <a-input v-model="form.userInfo.name" placeholder="请输入姓名"/>
        </a-form-model-item>
        <a-form-model-item label="电话" prop="phone">
          <a-input v-model="form.userInfo.phone" placeholder="请输入电话号码"/>
        </a-form-model-item>
        <a-form-model-item label="性别" prop="gender">
          <a-radio-group name="radioGroup" v-model="form.userInfo.gender">
            <a-radio value="男">男</a-radio>
            <a-radio value="女">女</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="部门" prop="governId">
          <a-select v-model="form.userInfo.govern" @change="changeGov" placeholder="请选择部门"
                    :showSearch="true" :labelInValue="true">
            <a-select-option v-for="item in options.govList" :key="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="单位" prop="regionId">
          <a-select v-model="form.userInfo.region" @change="changeReg" placeholder="请选择单位"
                    :showSearch="true" :labelInValue="true">
            <a-select-option v-for="item in options.regList" :key="item.id">
              {{ item.simpleName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="角色" prop="role">
          <a-select v-model="form.userInfo.role" placeholder="请选择角色">
            <a-select-option v-for="item in options.roleList" :key="item.id" :value="item.value">
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
      <div class="drawer-bottom-button">
        <a-button :style="{ marginRight: '8px' }" @click="closeForm">关闭</a-button>
        <a-button type="primary" @click="submitForm">保存</a-button>
      </div>
    </a-drawer>
    <a-modal title="重置密码" :visible.sync="show.resetPassword" width="30%" ok-text="确认" cancel-text="取消"
             @ok="submitResetPassword" @cancel="closeResetPassword">
      <a-form-model :model="form.resetPassword" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="新密码" prop="newPassword">
          <a-input-password v-model="form.resetPassword.newPassword"/>
        </a-form-model-item>
        <a-form-model-item label="重复密码" prop="againPassword">
          <a-input-password v-model="form.resetPassword.againPassword"/>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-table :data-source="dataSource" rowKey="id" :columns="columns" :pagination="true">
      <div slot="searchDropdown" style="padding: 8px"
           slot-scope="{ column }">
        <a-input :placeholder="`搜索${column.title}`" v-model="searchText[column.dataIndex]"
                 style="width: 188px; margin-bottom: 8px; display: block;"
                 @pressEnter="handleSearch(searchText[column.dataIndex],column.dataIndex)"/>
        <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                  @click="handleSearch(searchText[column.dataIndex],column.dataIndex)">搜索
        </a-button>
        <a-button size="small" style="width: 90px" @click="handleReset(column.dataIndex)">重置</a-button>
      </div>
      <a-icon slot="searchIcon" slot-scope="filtered" type="search"/>
      <span slot="gender" slot-scope="gender" type="search">
            <a-tag color="pink" v-if="gender==='女'">女</a-tag>
            <a-tag color="blue" v-if="gender==='男'">男</a-tag>
          </span>
      <span slot="tags" slot-scope="tags">
            <a-tag v-for="tag in tags" :rowKey="tag.id" :color="tag.color">{{ tag.name }}</a-tag>
          </span>
      <span slot="status" slot-scope="status">
            <a-tag color="green" v-if="status === 0">正常</a-tag>
            <a-tag color="red" v-else>锁定</a-tag>
          </span>
      <span slot="action" slot-scope="text, record">
            <span v-if="record.role !== 0">
              <c-pop-button title="确认要删除吗" text="删除" @click="removeUser(record)" type="danger"/>
              <a-divider type="vertical"/>
            </span>
            <a-button type="primary" size="small" @click="editUser(record)">编辑</a-button>
            <a-divider type="vertical"/>
            <a-button type="primary" size="small" @click="showResetPassword(record)">重置密码</a-button>
          </span>
    </a-table>
  </div>
</template>

<script>

import CPopButton from "@/components/c-pop-button";
import CButton from "@/components/c-button";
import {SysApis} from "@/api/SysApis";
import {CustomApis as api} from "@/api/CustomApis";
import CTableSearch from "@/components/c-table-search"

export default {
  name: "users-list",
  components: {
    CButton,
    CPopButton,
    CTableSearch,
  },
  watch: {},
  data() {
    return {
      searchText: {},
      rules: {
        username: [
          {required: true, message: '请输入用户名', trigger: 'change'},
          {min: 2, max: 16, message: '长度为2-16个字符', trigger: 'change'},
          {whitespace: true, message: '请输入用户名', trigger: 'change'}
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'change'},
          {min: 8, max: 16, message: '长度为8-16个字符', trigger: 'change'},
          {whitespace: true, message: '请输入密码', trigger: 'change'}
        ],
        name: [
          {required: true, message: '请输入名称', trigger: 'change'},
          {min: 2, max: 16, message: '长度为2-16个字符', trigger: 'change'},
          {whitespace: true, message: '请输入名称', trigger: 'change'}
        ],
        phone: [
          {required: true, message: '请输入电话', trigger: 'change'},
          {whitespace: true, message: '请输入电话', trigger: 'change'},
          {min: 8, max: 16, message: '长度为8-16个字符', trigger: 'change'},
        ],
        gender: [
          {required: true, message: '请选择性别', trigger: 'change'},
        ],
        governId: [
          {required: true, message: '请选择', trigger: 'change'},
        ],
        regionId: [
          {required: true, message: '请选择', trigger: 'change'},
        ],
        role: [
          {required: true, message: '请选择角色', trigger: 'change'},
        ],
        newPassword: [
          {required: true, message: '请输入密码', trigger: 'change'},
          {min: 8, max: 16, message: '长度为8-16个字符', trigger: 'change'},
          {whitespace: true, message: '请输入密码', trigger: 'change'}
        ],
        againPassword: [
          {required: true, message: '请重复输入密码', trigger: 'change'},
          {min: 8, max: 16, message: '长度为8-16个字符', trigger: 'change'},
          {whitespace: true, message: '请重复输入密码', trigger: 'change'}
        ],
      },
      columns: [
        {
          dataIndex: 'username',
          key: 'username',
          title: '用户名',
          scopedSlots: {
            filterDropdown: 'searchDropdown',
            filterIcon: 'searchIcon',
          },
        },
        {
          dataIndex: 'name',
          title: '姓名',
          key: 'name',
          scopedSlots: {
            filterDropdown: 'searchDropdown',
            filterIcon: 'searchIcon',
          },
        },
        {
          dataIndex: 'gender',
          title: '性别',
          key: 'gender',
          scopedSlots: {
            filterDropdown: 'searchDropdown',
            filterIcon: 'searchIcon',
            customRender: 'gender'
          },
        },
        {
          dataIndex: 'phone',
          title: '电话',
          key: 'phone',
          scopedSlots: {
            filterDropdown: 'searchDropdown',
            filterIcon: 'searchIcon',
          },
        },
        {
          dataIndex: 'governName',
          title: '部门',
          key: 'governName',
          scopedSlots: {
            filterDropdown: 'searchDropdown',
            filterIcon: 'searchIcon',
          },
        },
        {
          dataIndex: 'regionName',
          title: '单位',
          key: 'regionName',
          scopedSlots: {
            filterDropdown: 'searchDropdown',
            filterIcon: 'searchIcon',
          },
        },
        {
          dataIndex: 'password',
          title: '密码',
          key: 'password',
        },
        {
          title: '操作',
          key: 'action',
          scopedSlots: {customRender: 'action'},
        },
      ],
      dataSource: [],
      count: 0,
      labelCol: {span: 5},
      wrapperCol: {span: 16},
      form: {
        type: 0,
        userInfo: {
          id: '',
          username: '',
          password: '',
          name: '',
          gender: '男',
          govern: {},
          region: {},
          governId: undefined,
          regionId: undefined,
          governName: '',
          regionName: '',
          phone: '',
          role: 1,
          status: null,
        },
        resetPassword: {
          id: '',
          newPassword: '',
          againPassword: '',
        },
      },
      options: {
        govList: [],
        regList: [],
        roleList: [
          // {id: '001', label: '超级管理员', value: '超级管理员'},
          {id: '002', label: '区本级审核用户', value: '区本级审核用户'},
          {id: '003', label: '教育局审核用户', value: '教育局审核用户'},
          {id: '004', label: '单位用户', value: '单位用户'},
        ],
      },
      show: {
        tags: false,
        userInfo: false,
        resetPassword: false,
      },
    };
  },
  activated() {
    this.getList()
  },
  mounted() {
  },
  methods: {
    submitSearch() {
      this.$http.post(`${SysApis.searchUser}`, this.searchText).then(result => {
        if (result.status !== 200) {
          this.$message.error(result.message);
          return
        }
        if (result.data !== null) {
          this.dataSource = result.data.sort((a, b) => {
            return b.id - a.id
          });
        }
      }).catch(function (error) {
        console.log('请求出现错误:', error);
      });
    },
    handleSearch(text, index) {
      this.submitSearch()
    },
    handleReset(index) {
      this.searchText[index] = ''
      this.submitSearch()
    },
    changeGov(item) {
      console.log(item)
      this.form.userInfo.governId = item.key
      this.form.userInfo.governName = item.label
      this.options.govList.forEach(gov => {
        if (gov.id === item.key) {
          this.options.regList = gov.regions
          if (this.form.userInfo.region.key) {
            this.form.userInfo.region.key = gov.regions[0].id
            this.form.userInfo.region.label = gov.regions[0].simpleName
          }
        }
      })
    },
    changeReg(item) {
      this.form.userInfo.regionId = item.key
      this.form.userInfo.regionName = item.label
      this.form.userInfo.region = item
    },
    checkIsSearchOrGet() {
      for (let key in this.searchText) {
        if (this.searchText[key] && this.searchText[key].length > 0) {
          return true
        }
      }
      return false
    },
    getGovList() {
      return this.$http.get(api.getGovList).then(result => {
        if (result.status !== 200) {
          this.$message.error(result.message);
          return;
        }
        if (result.data !== null) {
          this.options.govList = result.data
          return Promise.resolve({success: true})
        }
      }).catch(function (error) {
        console.error('出现错误:', error);
      });
    },
    refreshData() {
      this.getList()
    },
    getList() {
      this.$http.get(SysApis.userList).then(result => {
        if (result.status !== 200) {
          this.$message.error(result.message);
          return;
        }
        if (result.data !== null) {
          this.dataSource = result.data.sort((a, b) => {
            return b.id - a.id
          });
        }
      }).catch(function (error) {
        console.error('出现错误:', error);
      });
    },
    addUser() {
      this.form.userInfo = {}
      this.form.type = 0
      this.getGovList()
      this.show.userInfo = true
    },
    async editUser(e) {
      let govListStatus = await this.getGovList()
      if (govListStatus.success) {
        this.form.type = 1
        this.form.userInfo = e
        if (this.form.userInfo.governId) {
          this.options.govList.forEach(gov => {
            if (this.form.userInfo.governId === gov.id) {
              this.form.userInfo.govern = {key: gov.id, label: gov.name}
              this.options.regList = gov.regions
              gov.regions.forEach(reg => {
                if (reg.id === e.regionId) {
                  this.form.userInfo.region = {key: reg.id, label: reg.simpleName}
                }
              })
            }
          })
        }
        this.show.userInfo = true
      }
    },
    submitForm() {
      if(this.form.type === 0&&!this.checkPassWord(this.form.userInfo.password, this.form.userInfo.againPassword)){
      	return;
      }
      let url = this.form.type === 0 ? SysApis.addUser : SysApis.editUser
      this.options.govList.forEach(e => {
        if (e.id === this.form.userInfo.governId) {
          this.form.userInfo.governName = e.name
        }
      })
      this.options.regList.forEach(e => {
        if (e.id === this.form.userInfo.regionId) {
          this.form.userInfo.regionName = e.simpleName
        }
      })
      this.$http.post(url, this.form.userInfo).then(result => {
        if (result.status !== 200) {
          this.$message.error(result.message);
          return;
        }
        this.closeForm()
      }).catch(function (error) {
        console.error('出现错误:', error);
      });
    },
    lockUser(e) {
      this.$http.post(`${SysApis.lockUser}/${e.id}`).then(result => {
        if (result.status !== 200) {
          this.$message.error(result.message);
          return
        }
        this.refreshData()
        this.$message.success(result.message)
      }).catch(function (error) {
        console.log('请求出现错误:', error);
      });
    },
    unlockUser(e) {
      this.$http.post(`${SysApis.unlockUser}/${e.id}`).then(result => {
        if (result.status !== 200) {
          this.$message.error(result.message);
          return
        }
        this.refreshData()
        this.$message.success(result.message)
      }).catch(function (error) {
        console.log('请求出现错误:', error);
      });
    },
    removeUser(e) {
      const _this = this;
      this.$confirm({
        title: '确认操作?',
        cancelText: '取消',
        okText: '确定',
        onOk() {
          _this.$http.post(`${SysApis.delUser}/${e.id}`).then(result => {
            if (result.status !== 200) {
              _this.$message.error(result.message);
              return
            }
            _this.$message.success(result.message)
            _this.refreshData()
          }).catch(function (error) {
            console.log('请求出现错误:', error);
          });
        },
      });
    },
    closeForm() {
      this.form.userInfo = {
        id: '',
        username: '',
        password: '',
        name: '',
        gender: '男',
        governId: null,
        regionId: null,
        governName: '',
        regionName: '',
        phone: '',
        role: 1,
        status: null,
      }
      this.show.userInfo = false
      this.refreshData()
    },
    checkUsername() {
      let username = this.form.userInfo.username
      this.$http.get(`${SysApis.checkUsername}/${username}`).then(result => {
        if (result.status !== 200) {
          this.$message.error(result.message);
          return;
        }
        this.$message.success(result.message);
      }).catch(function (error) {
        console.error('出现错误:', error);
      });
    },
    closeResetPassword() {
      this.show.resetPassword = false
      this.form.resetPassword = {
        id: '',
        newPassword: '',
        againPassword: '',
      }
      this.refreshData()
    },
    showResetPassword(e) {
      this.form.resetPassword.id = e.id
      this.show.resetPassword = true
    },
    submitResetPassword() {
      if(!this.checkPassWord(this.form.resetPassword.newPassword, this.form.resetPassword.againPassword)){
      	return;
      }
      this.$http.post(SysApis.resetPassword, this.form.resetPassword).then(result => {
        if (result.status !== 200) {
          this.$message.error(result.message);
          return
        }
        this.$message.success(result.message)
        this.closeResetPassword()
      }).catch(function (error) {
        console.log('请求出现错误:', error);
      });
    },
    checkPassWord(pwd, repeatPwd){
    	console.log(pwd);
    	console.log(repeatPwd);
    	let temp = true;
    	if(!pwd){
    		temp = false;
    	}else if(!this.checkPwdRule(pwd)){
	    	this.$message.error('密码需包含大小写字母、数字、符号，且不能出现类似111、aaa、123、abc的情况，长度8-16位！');
	    	temp = false;
    	}else if(repeatPwd !== pwd){
    		this.$message.error('重复密码与密码需一致！');
    		temp = false;
    	}
    	return temp;
    },
    checkPwdRule(pwd){
    	let temp = false;
    	let pwdRegx = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*\W)[a-zA-Z\d\W]{8,16}$/;
    	if(pwdRegx.test(pwd)){
    		let samePwdRegx = /(\w)*(\w)\2{2}(\w)*/g;
    		if(!samePwdRegx.test(pwd)&&this.checkLxPwd(pwd)){
	    		temp = true;
    		}
    	}
    	return temp;
    },
    checkLxPwd(pwd){
    	let pwdArr = pwd.split('');
    	let temp = true;
    	for(let i=1; i<pwdArr.length-1; i++){
    		let prevIndex = pwdArr[i-1].charCodeAt(),
    			nowIndex = pwdArr[i].charCodeAt(),
    			nextIndex = pwdArr[i+1].charCodeAt();
    		if((nextIndex-nowIndex) === 1&&(nowIndex-prevIndex) === 1){
    			temp = false;
    			break;
    		}
    	}
    	return temp;
    }
  }
}
</script>

<style scoped>
.drawer-bottom-button {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  z-index: 1;
}
</style>
